import React, { useCallback, useEffect, useState } from 'react';
import { Container, Enabled, Disabled } from './styles';

const OperationalStatus = ({ operationalStatus }) => {
  const [status, setStatus] = useState([]);

  const getStatus = useCallback(
    (name) => {
      const groups = operationalStatus.map(({ group }) => group);
      let status = null;

      groups.map((group) =>
        group.map((statusObject) => {
          if (statusObject?.name === name) {
            status = statusObject;
          }
          return status;
        })
      );

      return status;
    },
    [operationalStatus]
  );

  useEffect(() => {
    if (operationalStatus) {
      const normal = getStatus('Sta_SemAlarme');
      const failure = getStatus('Sta_EmAlarme');
      const running = getStatus('Sta_Rodando');
      const manual = getStatus('Sta_EmManual');
      const automatic = getStatus('Sta_EmAutomatico');
      const stopped = getStatus('Sta_Parado');
      const remote = getStatus('Sta_Remoto');
      const local = getStatus('Sta_Local');
      const blocked = getStatus('Sta_Bloqueado');

      if (
        normal &&
        failure &&
        running &&
        manual &&
        automatic &&
        stopped &&
        remote &&
        local &&
        blocked
      ) {
        const formattedStatus = [
          [
            {
              ...normal,
              critical: false,
            },
            {
              ...failure,
              critical: true,
            },
          ],
          [
            {
              ...running,
              critical: false,
            },
            {
              ...stopped,
              critical: true,
            },
          ],
          [
            {
              ...automatic,
              critical: false,
            },
            {
              ...manual,
              critical: false,
            },
          ],
          [
            {
              ...remote,
              critical: false,
            },
            {
              ...local,
              critical: false,
            },
          ],
          [
            {
              isOn: !blocked.isOn,
              label: 'Desbloqueado',
              name: 'Sta_Desbloqueado',
              critical: false,
            },
            {
              ...blocked,
              critical: true,
            },
          ],
        ];
        setStatus(formattedStatus);
      }
    }
  }, [operationalStatus, getStatus]);

  return status.map((statusPair) => (
    <Container key={`${statusPair[0].name}-${statusPair[1].name}`}>
      <Enabled active={statusPair[0].isOn} critical={statusPair[0].critical}>
        {statusPair[0].label}
      </Enabled>
      <Disabled active={statusPair[1].isOn} critical={statusPair[1].critical}>
        {statusPair[1].label}
      </Disabled>
    </Container>
  ));
};

export default OperationalStatus;
